import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from './confirm-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  constructor(public dialog: MatDialog) { }

  openConfirmDialog(translateKeyText: string, translateKeyTextDescription?: string ){
    const dialogRef = this.dialog.open(ConfirmDialogComponent,{
      width: '490px',
      disableClose: true,
    })
    let instance = dialogRef.componentInstance;
    instance.translateMessage = translateKeyText;
    instance.translateMessageDescription = translateKeyTextDescription
    return dialogRef;
    }
}
